import { useState, useEffect } from "react";
// @mui material components
import Container from "@mui/material/Container";
import { Grid, Card, Divider } from "@mui/material";
import MDTypography from "dashboard/components/MDTypography";
import MDBox from "dashboard/components/MDBox";
// Material Kit 2 React examples
import CounterCard from "dashboard/examples/Cards/CounterCard";
import countersData from "data/counters.json";
import Brevet from "assets/images/icons/diplome.png";
import Categories from "assets/images/icons/categories.png";
import productBox from "assets/images/icons/boite-de-livraison.png";



const imagStyle= {
  objectFit:"cover",
  width : "30%",
  display: "block", 
  margin: "auto",
  veticalAlign : "baseline",
  filter : 'invert(.5)',
  p : 2
}
function Counters({ lang =  'fr'}) {
  const [counters, setCounters] = useState([]);
  const iconMap = {
    brevet: Brevet,
    categories: Categories,
    productBox: productBox,
  };

  useEffect(() => {
    const selected = countersData[lang] || countersData["fr"];
    setCounters(selected);
  }, [lang]);


  return (
    <Card id="counter" component="section"  py={3}>
      <Container>
        <MDTypography sx={{my:3, textAlign:"center", textTransform :"uppercase"}} variant="h2">Une solution pour chaque besoin</MDTypography>
        <Grid container   sx={{ mx: "auto" }}>
          {counters.map((item, index) => (
          <Grid key={index} item xs={12} md={3} lg={counters.length < 7 ? 12/counters.length -.1 : 2} display="flex" justifyContent="center">
            <CounterCard
              icon={<MDBox sx={imagStyle} component="img" src={iconMap[item.icon]} />}
              count={item.title}
              suffix={item.suffix}
              title=""
              description={item.text}
              separator=""
            />

            {/* Insert divider except after the last item */}
            {index < counters.length - 1 && (
              <Divider
                orientation="vertical"
                flexItem
                sx={{ display: { xs: "none", md: "block" }, mx: 0 }}
              />
            )}
          </Grid>
          ))}
        </Grid>
      </Container>
    </Card>
  );
}

export default Counters;
